import { Box, IconButton, styled, Typography } from "@mui/material"
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

const StyledCard = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    padding: '20px',
    border: '1px solid var(--Light-Gray)',
    borderRadius: '12px',
    boxShadow: '0px 1px 2px 0px #0205111A'
})

const CustomButtonStyle = styled(IconButton)({
    border: '1px solid var(--Interviewer-Near-White)',
    borderRadius: '8px',
    width: '40px',
    height: '40px'
})

interface AdminCategoryCardProps {
    id: string;
    name: string;
    description: string;
    onEdit?: (id: string) => void;
    onDelete?: (id: string) => void;
}

const AdminCategoryCard = ({ id, name, description, onEdit, onDelete }: AdminCategoryCardProps) => {
    return (
        <StyledCard>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px'}}>
                <Typography variant="h3" sx={{fontSize: '16px'}}>{name}</Typography>
                <Typography sx={{fontSize: '14px', color: 'var(--Interviewer-Lighter-Black)'}}>{description}</Typography>
            </Box>
            <Box sx={{display: 'flex', gap: '16px'}}>
                <CustomButtonStyle onClick={() => onEdit?.(id)}>
                    <ModeEditOutlineOutlinedIcon fontSize="small" color="primary" sx={{width: '18px', height: '18px'}} />
                </CustomButtonStyle>
                <CustomButtonStyle onClick={() => onDelete?.(id)}>
                    <DeleteOutlineOutlinedIcon fontSize="small" color="primary" sx={{width: '18px', height: '18px'}} />
                </CustomButtonStyle>
            </Box>
        </StyledCard>
    )    
}
export default AdminCategoryCard